<template>
  <div
    class="relative"
    @dragenter.prevent="onDragEnter"
    @dragleave.prevent="onDragLeave"
    @drop="isDraggedOver = false"
    @dragover.prevent="onDragOver"
  >
    <div
      class="h-0.5"
      :class="{
        'bg-blue-500 h-0.5 w-full': isDraggedOver,
      }"
    />
    <div v-if="isDragging" class="absolute h-10 -top-5 w-full z-50" />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

defineProps<{
  isDragging: boolean
}>()
const isDraggedOver = ref(false)
function onDragEnter() {
  isDraggedOver.value = true
}

function onDragLeave() {
  isDraggedOver.value = false
}

function onDragOver(event: DragEvent) {
  event.dataTransfer!.dropEffect = 'move'
  event.preventDefault()
}
</script>
